import { Injectable } from '@angular/core';

@Injectable()
export class SharedService {

  public selectedCourseId = null;

  public attendance = {
    course: null
  };

  public assessment = {
    course: null,
    exam: null,
    rlp: null,
    diplomaPaper: null
  };

  public classList = [];

  constructor() { }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/services/shared/shared.service.ts